import { render } from "./InputRequiredText.vue?vue&type=template&id=0446ac58&scoped=true"
import script from "./InputRequiredText.vue?vue&type=script&lang=js"
export * from "./InputRequiredText.vue?vue&type=script&lang=js"

import "./InputRequiredText.vue?vue&type=style&index=0&id=0446ac58&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1263437306/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0446ac58"]])

export default __exports__